export default __webpack_public_path__ + "static/media/our-team-member-07.f23e48b0.jpg";